import styled from 'styled-components';

export const LabelFormStyled = styled.div`
  .div_label {
    font-family: ${({ theme, labelFontFamily }) => labelFontFamily ? labelFontFamily : theme.FONT.STYLE.MEDIUM};
    color: ${({ theme, labelColor }) => labelColor ? labelColor : theme.COLORS.GRAY_23};
    font-size: ${({ theme, labelSize }) => labelSize ? labelSize : theme.FONT.SIZE.S18};
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 8px;
    .label_text_container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .label_text {
        display: flex;
        align-items: center;
        column-gap: 2px;
        .required {
          font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
          color: ${({ theme }) => theme.COLORS.RED_1};
          font-size: ${({ theme }) => theme.FONT.SIZE.S16};
        }
      }
    }
    .sub_label {
      font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
      color: ${({ theme, subLabelColor }) => subLabelColor ? subLabelColor : theme.COLORS.GRAY_24};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    }
  }
`;
